import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLocation } from "../utils/GetLocation"; // Asegúrate de la ruta correcta

const CourseCard = ({ id, image, students, duration, titleMain, rating, reviews, values }) => {
    const [price, setPrice] = useState({ oldPrice: "No Disponible", newPrice: "No Disponible" });
    
    useEffect(() => {
        getLocation().then(({ countryCode }) => {
            const countryValues = values[countryCode] || values["us"]; // Si el país no está definido, usa USD
            setPrice({ oldPrice: countryValues.oldPrice.toLocaleString("de-DE"), newPrice: countryValues.newPrice.toLocaleString("de-DE"), currency: countryValues.currency });
        });
    }, [values]);

    // --- Lógica de Redirección Dinámica ---
    // Determina la ruta correcta basada en el ID del curso.
    let coursePath;
    if (id === "5" || id === "1" || id === "10") {
        coursePath = `/tech/course-details/${id}`;
    } else if (id === "2") {
        coursePath = `/course-details/${id}`; 
    } else if (id === "3") {
        coursePath = `/002/course-details/${id}`;
    } else if (id === "12") {
        coursePath = `/tech/course-details-ws/${id}`;
    } else {
        coursePath = `/001/course-details/${id}`;
    }
    // --- Fin de la Lógica de Redirección ---

    return (
        <div className="col-lg-4 col-md-6 mb-4">
            <div className="rounded overflow-hidden mb-2 bg-secondary p-4">
                {/* El Link ahora usa la ruta dinámica */}
                <Link to={coursePath}><img className="img-fluid w-100 rounded" src={image} alt={titleMain} style={{ height: "220px", objectFit: "cover" }} /></Link>
                <div className="bg-secondary p-4">
                    <div className="d-flex justify-content-between mb-3">
                        <small>
                            <i className="fa fa-users text-primary mr-2"></i>{students} Estudiantes
                        </small>
                        <small>
                            <i className="far fa-clock text-primary mr-2"></i>{duration}
                        </small>
                    </div>
                    <div className="text-title-course">
                        {/* El Link ahora usa la ruta dinámica */}
                        <Link to={coursePath} className="nav-item nav-link active h5"><b>{titleMain}</b></Link>
                    </div>
                    <div className="border-top mt-4 pt-4 d-flex justify-content-between">
                        <h6 className="m-0">
                            <i className="fa fa-star text-primary mr-2"></i>{rating} <small>({reviews})</small>
                        </h6>
                        <del>
                            <h5 className="m-0">{price.oldPrice} {price.currency}</h5>
                        </del>
                    </div>
                    <p className="precio-preventa">
                        Precio HOY: <span className="price-course">{price.newPrice} {price.currency}</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CourseCard;
